/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import CustomerRoutes from './customer.routes';
import CustomerDirective from './customer.directive';
import CustomerTableConfig from './customer-table.config';
import CustomerDetailsController from './customer-details.controller';

export default angular.module('tektelic.customer', [])
    .config(CustomerRoutes)
    .controller('CustomerDetailsController', CustomerDetailsController)
    .directive('tkCustomer', CustomerDirective)
    .factory('customerTableConfig', CustomerTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/customer/index.js